<template>
  <div class="certificateGetManage">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="班级名称">
          <el-input v-model="filter.skuName" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="考场名称">
          <el-input v-model="filter.title" placeholder="请输入考场名称"></el-input>
        </el-form-item>
        <el-form-item label="所属项目">
          <el-select v-model="filter.projectId" placeholder="请选择所属项目">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放状态">
          <el-select v-model="filter.receiptState" placeholder="请选择发放状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待发放" value="1"></el-option>
            <el-option label="已发放" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购课时间">
          <el-date-picker
            v-model="dateList"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px;">
      <el-upload style="display: inline-block" :show-file-list="false" class="upload-demo" accept=".xlsx" :action="uploadbaseURL" :on-success="uploadSuccess" :before-upload="uploadBefore" :on-error="uploadError" :headers="uploadHeader">
        <el-button size="small" type="primary" :loading="exportLocalLoading">导入发货信息</el-button>
      </el-upload>
      <el-button type="primary" size="small" style="margin-left: 10px" @click="handleExport">导出</el-button>
      <span>&emsp;PS:一次导入最多支持500条，如超过，请分批导入。</span>
      <el-table :data="list" border style="margin-top: 10px">
        <el-table-column align="center" label="班级名称" prop="skuName" width=""></el-table-column>
        <el-table-column align="center" label="所属项目" prop="projectName" width=""></el-table-column>
        <el-table-column align="center" label="考场名称" prop="title" width=""></el-table-column>
        <el-table-column align="center" label="用户昵称" prop="userName" width=""></el-table-column>
        <el-table-column align="center" label="用户电话" prop="phone" width="110">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收货姓名" prop="receiptName" width=""></el-table-column>
        <el-table-column align="center" label="收货手机号" prop="receiptPhone" width="110"></el-table-column>
        <el-table-column align="center" label="省" prop="receiptProvince" width=""></el-table-column>
        <el-table-column align="center" label="市" prop="receiptCity" width=""></el-table-column>
        <el-table-column align="center" label="区" prop="receiptArea" width=""></el-table-column>
        <el-table-column align="center" label="购课时间" prop="payTime" width=""></el-table-column>
        <el-table-column align="center" label="详细地址" prop="receiptDetailed" width="200"></el-table-column>
        <el-table-column align="center" label="发送状态" prop="" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.receiptState === 1">待发放</span>
            <span v-if="scope.row.receiptState === 2">已发放</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="快递单号" prop="receiptNumber" width=""></el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import { getPageList } from "@/api/product/project";
import { receiveCertificateList, receiveCertificateListByAgent } from "@/api/certificate/index";
import { getAppUserInfo } from "@/api/common";
import FileExport from "@/components/FileExport.vue";
import { baseURL } from '@/api/request'
import Cookies from 'js-cookie'
export default {
  name: 'CertificateGetManage',
  components: { FileExport },
  data () {
    return {
      uploadbaseURL: `${baseURL}/product/adm/userTestPlan/importCertificate`,
      uploadHeader: {},
      projectList: [],
      filter: {
        page: 1,
        limit: 10,
        skuName: '',
        title: '',
        projectId: '',
        receiptState: '',
        startDate: '',
        endDate: ''
      },
      list: [],
      total: 0,
      exportLocalLoading: false
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.filter.startDate, this.filter.endDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.startDate = v[0] + ' 00:00:00' || ''
          this.filter.endDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.startDate = ''
          this.filter.endDate = ''
        }
      }
    }
  },
  created() {
    this.getPageList()
    this.getList()
    const token = Cookies.get('tvToken') || Cookies.get('token')
    if (token) {
      this.uploadHeader = {
        Authorization: 'Bearer ' + token
      }
    }
  },
  methods: {
    async getPageList() {
      const res = await getPageList({page: 1, limit: -1})
      this.projectList = res.data.records
    },
    async getList() {
      let res
      if (this.checkAdmin()) {
        res = await receiveCertificateList(this.filter)
      } else {
        res = await receiveCertificateListByAgent(this.filter)
      }
      this.list = res.data.records
      this.total = +res.data.total
    },
    uploadSuccess (response, file, fileList) {
      this.tableLocalData = response.data
      this.exportLocalLoading = false
      this.$message.success('导入成功')
      this.getList()
    },
    uploadBefore (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx') {
        if (this.exportLocalLoading == false) {
          this.exportLocalLoading = true
          return true
        } else {
          this.$message.error('正在导入中请不要进行操作！')
        }
      } else {
        this.$message.error('文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx的EXCEL文件。')
      }
      return false
    },
    uploadError (error, file, fileList) {
      this.$message.error('网络异常，请联系管理员。')
      this.exportLocalLoading = false
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    // 导出
    handleExport() {
      this.$refs.FileExport.init(
        { ...this.filter, payType: "DGZZ" }, // 搜索表单参数
        "jsw-product-provider", // 后端对应业务线服务
        "/product/adm/userTestPlan/exportCertificate", // 导出-对应的接口
        1, //  状态：0get、1post
        "证书发货状态.xlsx" //文件名称
      );
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.list.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
